import styled from "styled-components";
import { styled as muiStyled } from '@mui/material';
import { StyledButton } from "../../pages/Dashboard/components/Filter/RetrofitDateModal/styles";


export const HeaderModal = styled.header`
  background: #263465; 
  padding: 16px 24px; 
  display: flex;
  justify-content: space-between;
  font-family: var(--luft-fonts);
  font-weight: 70;
  font-size: 18px;
  line-height: 24px;
  color: #fff;
`;

export const SessionExpiredContent = styled.div`
  display: flex; 
  flex-direction: column;

  > span {
    font-family: var(--luft-fonts);
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;

    color: rgba(0, 0, 0, 0.54);
  }
`;

export const Button = muiStyled(StyledButton)(() => ({
  marginTop: '24px',
}))
